<template>
	<div class="input-with-placeholder-label" :class="{ 'input-with-placeholder-label--big': bigSearch, 'input-with-placeholder-label--centered': centerLabel }" >
		<input :type="inputType" v-bind:id="inputId" required class="form-control w-100" :aria-labelledby="'label-' + inputId" v-model="fieldValue" @change="fieldChanged" :class="{'field-filled': fieldValue }" />
		<label :id="'label-' + inputId" v-bind:for="inputId">{{ labelText }}</label>
	</div>
</template>

<style lang="scss">

	$heightBig: 40px;

	.input-with-placeholder-label {
		margin-top: 24px;
		position: relative;


		.errors {
			font-family: $fontFamilyName;
			display: none;
			margin-top: 12px;
			color: $errorColor;
		}

		// make errors visible in case of invalidation
		input.error ~ .errors {
			display: block;
		}

		input.error + label {
			color: $errorColor;
		}

		&.error label {
			color: $errorColor;
		}



		&--centered {
			label {
				text-align: center;
				width: calc(100%);
				left: 0 !important;
			}
		}

		label {
			position: absolute;
			top: 0px;
			left: 10px;
			font-weight: 200;
			font-size: 14px;
			color: #333333;
			letter-spacing: 0;
			line-height: $heightBig;
			transition: all 0.3s;
			pointer-events: none;
		}

		input {
			background: #fff;
			border: 1px solid $mediumGrey;
			border-radius: 0;
			height: $heightBig;
			padding-left: 10px;

		}

		@mixin labelShrink($topPos) {
			font-size: 11px;

			top: $topPos;
			left: 0;
			color: $navyBlue;
			font-weight: 600;
		}

		// IE polyfill {
		&.focus-within input + label, input.valid + label, input.error + label {
			@include labelShrink(-$heightBig + 5px);
		}
		// }

		input:valid + label, input:focus-within + label, input:hover + label, input[value]:not([value=""]) + label {
			@include labelShrink(-$heightBig + 5px);
		}

		// For custom and kentico forms
		.field-filled + label,
		&.field-filled + label,
		&.field-filled label.control-label,
		&:hover label.control-label {
			@include labelShrink(-$heightBig + 5px);
		}

		&--big {
			height: 46px;
			input {
				margin-top: -7px;
				font-family: $fontFamilyName;
				font-weight: 200;
				font-size: rem(30);
				line-height: rem(30);
				color: $black;
				border: 0 !important;

				background: transparent;
				border-radius: 0;

				&:focus {
					outline: $lightBlue auto 1px;
					outline-style: solid;
					outline-offset: 0;
					border: 0;
				}
			}

			label {
				top: 10px;
				font-size: 22px;
			}

			&.focus-within input + label {
				@include labelShrink(-$heightBig);
			}
			input.valid + label {
				@include labelShrink(-$heightBig);
			}
			input.error + label {
				@include labelShrink(-$heightBig);
			}

			input:valid + label, input:focus-within + label, input:hover + label {
				@include labelShrink(-$heightBig);
			}

			&.field-filled input + label {
				@include labelShrink(-$heightBig + 5px);
			}


		}



	}

</style>


<script>

export default {
	name: "InputWithPlaceholderLabel",
	components: {

	},
	props: ["inputId", "labelText", "bigSearch", "centerLabel", "inputType" ],
	data() {
		return {
			fieldValue: ""
		}
	},
	methods: {
		fieldChanged() {
			this.$emit("input", this.fieldValue);
		}
	}
}

</script>